import * as types from './types';
import auth from '../../../utils/auth';

export default {
  load(context) {
    auth.getConf().then((response) => {
      context.commit(types.CONFIGURATION_LOADED, response.CONF);
    });
  },
};




// WEBPACK FOOTER //
// ./src/store/modules/conf/actions.js